module.exports = __webpack_public_path__ + "img/poly-2.35a177c7.png";